import React from 'react'

import { FullRequestHotel, Request } from 'src/types'

import { WrapCard } from '../../../../../styles'

import List from './list'

type Props = {
  request: Request
  selectedHotels: FullRequestHotel[]
  setSelectedHotels: React.Dispatch<React.SetStateAction<FullRequestHotel[]>>
}

function SearchResultCard({
  request,
  selectedHotels,
  setSelectedHotels
}: Props): JSX.Element {
  return (
    <WrapCard
      data-test-id="hotel-result-card"
      title="web.services.hotels.search-result"
    >
      <List
        request={request}
        selectedHotels={selectedHotels}
        setSelectedHotels={setSelectedHotels}
      />
    </WrapCard>
  )
}

export default SearchResultCard
